$('body').on('change', '.staff-application .history', function() {
    var $this = $(this);
    var option = $('option:selected', $this);
    
    $('[name="last_summer_camp_other"]').removeClass('required');
    $('[name="last_summer_camp_other"]').parent('li').addClass('hidden');

    if (option.attr('data-other') === 'Yes') {
        $('[name="last_summer_camp_other"]').addClass('required');
        $('[name="last_summer_camp_other"]').parent('li').removeClass('hidden');
        $('[name="last_summer_camp_other"]').select();
    }

    if (option.attr('data-reference') === 'No') {
        $('input, select', '.staff-application .references').removeClass('required');
        $('input, select', '.staff-application .references').prop('disabled', true);
        $('li', '.staff-application .references').addClass('hidden');
    } else {
        $('input, select', '.staff-application .references').addClass('required');
        $('input, select', '.staff-application .references').prop('disabled', false);
        $('li', '.staff-application .references').removeClass('hidden');
    }
    
    return false;
});

$('body').on('submit', '.staff-application form, .staff-application-refernece form', function () {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };

    var error = false;
    var card = $this.parents('.staff-application, .staff-application-refernece');
    card.find('.error').removeClass('error');

    if(card.find('input[name="avatar"]').val() === '') {
        showError('Error', 'Please upload a profile picture');
        return false;
    }

    card.find('.required').each(function () {
        var input = $(this);

        if (input.attr('type') === 'radio') {
            if (!card.find('input[name="' + input.attr('name') + '"]:checked').length) {
                console.log(input.attr('name'));
                error = true;
            }
        }

        if (input.attr('type') === 'checkbox') {
            if (!input.prop('checked')) {
                console.log(input.attr('name'));
                error = true;
            }
        }

        if (input.val() === '') {
            input.addClass('error');
            console.log(input.attr('name'));
            error = true;
        }
    });

    if (error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }

    loading();
    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: fields,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();
            
            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            showError('Success', data.message, data.button, data.href);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});



$('body').on('change', '.staff-shirt-size [name="shirt_size"]', function () {
    $(this).parents('form').submit();
});

$('body').on('change', '.staff-transportation [name="location"]', function () {
    var $this = $(this);

    if($this.attr('data-other') == 'yes') {
        $('.staff-transportation .location-other').removeClass('hidden');
        $('.staff-transportation .location-other input').addClass('required');
        $('.staff-transportation .location-other input').focus();
    } else {
        $('.staff-transportation .location-other').addClass('hidden');
        $('.staff-transportation .location-other input').removeClass('required');
    }
});


$('body').on('submit', '.staff-other-info form, .staff-shirt-size form, .staff-transportation form, .staff-otc-medications form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;
    var card = $this.parents('.card');
    card.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!card.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);

            if(data.location) {
                window.location.href = data.location;
                return false;
            }
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


// prescription
$('body').on('click', '.add-staff-prescription-trigger', function () {
    var data = $(this).parents('.staff-prescriptions');
    var action = $('.add-staff-prescription form').attr('data-action').replace('{staff_application}', data.attr('data-staff_application'));
    $('.add-staff-prescription form').attr('action', action);

    openModal('.add-staff-prescription');
    return false;
});

$('body').on('click', '.edit-staff-prescription-trigger', function () {
    var data = $(this).parents('.staff-prescription');
    var action = $('.edit-staff-prescription form').attr('data-action').replace('{staff_prescription}', data.attr('data-staff_prescription'));
    $('.edit-staff-prescription form').attr('action', action);

    $('.input-target input').removeClass('required');
    $('.input-target input').addClass('hidden');

    $('.edit-staff-prescription [name="name"]').val(data.attr('data-name'));
    $('.edit-staff-prescription [name="dosage"]').val(data.attr('data-dosage'));
    $('.edit-staff-prescription [name="method"]').val(data.attr('data-method'));
    $('.edit-staff-prescription [name="start_date"]').val(data.attr('data-start_date'));
    $('.edit-staff-prescription [name="end_date"]').val(data.attr('data-end_date'));
    $('.edit-staff-prescription [name="controlled_drug"]').prop('checked', data.attr('data-controlled_drug') ? true : false);
    $('.edit-staff-prescription [name="instructions"]').val(data.attr('data-instructions'));
    $('.edit-staff-prescription [name="side_effects"]').val(data.attr('data-side_effects'));
    $('.edit-staff-prescription [name="side_effects_plan"]').val(data.attr('data-side_effects_plan'));
    $('.edit-staff-prescription [name="self_administered"]').prop('checked', data.attr('data-self_administered') ? true : false);

    $('.edit-staff-prescription [name="known_allergies"]').prop('checked', data.attr('data-known_allergies') ? true : false);
    if (data.attr('data-known_allergies')) {
        $('.edit-staff-prescription [name="known_allergies_description"]').addClass('required');
        $('.edit-staff-prescription [name="known_allergies_description"]').val(data.attr('data-known_allergies_description'));
        $('.edit-staff-prescription [name="known_allergies_description"]').parents('.input-target').removeClass('hidden');
    }

    $('.edit-staff-prescription [name="medication_reaction"]').prop('checked', data.attr('data-medication_reaction') ? true : false);
    if (data.attr('data-medication_reaction')) {
        $('.edit-staff-prescription [name="medication_reaction_description"]').addClass('required');
        $('.edit-staff-prescription [name="medication_reaction_description"]').val(data.attr('data-medication_reaction_description'));
        $('.edit-staff-prescription [name="medication_reaction_description"]').parents('.input-target').removeClass('hidden');
    }

    $('.edit-staff-prescription [name="medication_interaction"]').prop('checked', data.attr('data-medication_interaction') ? true : false);
    if (data.attr('data-medication_interaction')) {
        $('.edit-staff-prescription [name="medication_interaction_description"]').addClass('required');
        $('.edit-staff-prescription [name="medication_interaction_description"]').val(data.attr('data-medication_interaction_description'));
        $('.edit-staff-prescription [name="medication_interaction_description"]').parents('.input-target').removeClass('hidden');
    }

    $('.edit-staff-prescription [name="auth_first_name"]').val(data.attr('data-auth_first_name'));
    $('.edit-staff-prescription [name="auth_last_name"]').val(data.attr('data-auth_last_name'));
    $('.edit-staff-prescription [name="auth_relationship"]').val(data.attr('data-auth_relationship'));
    $('.edit-staff-prescription [name="auth_administering_method"]').val(data.attr('data-auth_administering_method'));

    $('.edit-staff-prescription input[name="schedules[]"]').prop('checked', false);
    var schedules = JSON.parse(data.attr('data-schedule'));
    $.each(schedules, function (index, schedule) {
        $('.edit-staff-prescription input[name="schedules[]"][value="' + schedule + '"]').prop('checked', true);
    });

    openModal('.edit-staff-prescription');
    return false;
});

$('body').on('change', '.staff-prescription .target', function () {
    var $this = $(this);
    var prescription = $this.parents('.staff-prescription');
    if ($this.prop('checked')) {
        prescription.find('.input-target[data-target="' + $this.attr('data-target') + '"]').removeClass('hidden');
        prescription.find('.input-target[data-target="' + $this.attr('data-target') + '"] input').addClass('required');
        prescription.find('.input-target[data-target="' + $this.attr('data-target') + '"] input').focus();
    } else {
        prescription.find('.input-target[data-target="' + $this.attr('data-target') + '"]').addClass('hidden');
        prescription.find('.input-target[data-target="' + $this.attr('data-target') + '"] input').removeClass('required');
    }
});

$('body').on('submit', '.add-staff-prescription form, .edit-staff-prescription form', function () {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };

    var error = false;
    var modal = $this.parents('.modal');
    modal.find('.required').each(function () {
        var input = $(this);

        if (input.attr('type') === 'radio') {
            if (!modal.find('input[name="' + input.attr('name') + '"]:checked').length) {
                error = true;
            }
        }

        if (input.attr('type') === 'checkbox') {
            if (!input.prop('checked')) {
                error = true;
            }
        }

        if (input.val() === '') {
            error = true;
        }
    });

    if (error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }

    loading();
    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: fields,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);

            if (data.location) {
                window.location.href = data.location;
                return false;
            }
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-staff-prescription', function (data) {
    console.log(data);

    if ($('.staff-prescription[data-staff_prescription="' + data.staff_prescription + '"]').length) {
        var prescription = $('.staff-prescription[data-staff_prescription="' + data.staff_prescription + '"]');

        prescription.attr('data-staff_prescription', data.staff_prescription);
        prescription.attr('data-staff_application', data.staff_application);
        prescription.attr('data-medication_form', data.medication_form);
        prescription.attr('data-medication_form_name', data.medication_form_name);
        prescription.attr('data-name', data.name);
        prescription.attr('data-dosage', data.dosage);
        prescription.attr('data-method', data.method);
        prescription.attr('data-schedule', JSON.stringify(data.schedule));
        prescription.attr('data-instructions', data.instructions);
        prescription.attr('data-side_effects', data.side_effects);
        prescription.attr('data-side_effects_plan', data.side_effects_plan);
        prescription.attr('data-controlled_drug', data.controlled_drug);
        prescription.attr('data-self_administered', data.self_administered);
        prescription.attr('data-known_allergies', data.known_allergies);
        prescription.attr('data-known_allergies_description', data.known_allergies_description);
        prescription.attr('data-medication_reaction', data.medication_reaction);
        prescription.attr('data-medication_reaction_description', data.medication_reaction_description);
        prescription.attr('data-medication_interaction', data.medication_interaction);
        prescription.attr('data-medication_interaction_description', data.medication_interaction_description);
        prescription.attr('data-start_date', data.start_date_raw);
        prescription.attr('data-end_date', data.end_date_raw);
        prescription.attr('data-auth_first_name', data.auth_first_name);
        prescription.attr('data-auth_last_name', data.auth_last_name);
        prescription.attr('data-auth_relationship', data.auth_relationship);
        prescription.attr('data-auth_administering_method', data.auth_administering_method);

        prescription.find('[data-input="name"]').html(data.name);
        prescription.find('[data-input="dosage"]').html(data.dosage);
        prescription.find('[data-input="method"]').html(data.method);
        prescription.find('[data-input="start_date"]').html(data.start_date);
        prescription.find('[data-input="end_date"]').html(data.end_date);
        prescription.find('[data-input="status"]').html(data.status);
        prescription.find('[data-input="status"]').attr('data-color', data.status_color);
        prescription.find('[data-input="instructions"]').html(data.instructions);
        prescription.find('[data-input="side_effects"]').html(data.side_effects);
        prescription.find('[data-input="side_effects_plan"]').html(data.side_effects_plan);
        prescription.find('[data-input="schedule_parsed"]').html(data.schedule_parsed);

        if (data.medication_form && data.medication_form != '') {
            fileUploaderAddFile(prescription.find('.file-uploader'), data.medication_form_name, data.medication_form);
        } else {
            fileUploaderRemoveFile(prescription.find('.file-uploader'));
            // console.log(prescription.find('.file-uploader').length);
            // console.log(prescription.find('.file-uploader').html());
        }

        return
    }

    if ($('.staff-prescriptions[data-staff_application="' + data.staff_application + '"]').length) {
        $('.staff-prescriptions .staff-prescriptions-wrapper').append(`<div class="staff-prescription"
            data-staff_prescription="${data.staff_prescription}"
            data-staff_application="${data.staff_application}"
            data-medication_form="${data.medication_form}"
            data-medication_form_name="${data.medication_form_name}"
            data-name="${data.name}"
            data-dosage="${data.dosage}"
            data-method="${data.method}"
            data-schedule='${JSON.stringify(data.schedule)}'
            data-instructions="${data.instructions}"
            data-side_effects="${data.side_effects}"
            data-side_effects_plan="${data.side_effects_plan}"
            data-controlled_drug="${data.controlled_drug ? true : ''}"
            data-self_administered="${data.self_administered ? true : ''}"
            data-known_allergies="${data.known_allergies ? true : ''}"
            data-known_allergies_description="${data.known_allergies_description}"
            data-medication_reaction="${data.medication_reaction ? true : ''}"
            data-medication_reaction_description="${data.medication_reaction_description}"
            data-medication_interaction="${data.medication_interaction ? true : ''}"
            data-medication_interaction_description="${data.medication_interaction_description}"
            data-start_date="${data.start_date_raw}"
            data-end_date="${data.end_date_raw}"
            data-auth_first_name="${data.auth_first_name}"
            data-auth_last_name="${data.auth_last_name}"
            data-auth_relationship="${data.auth_relationship}"
            data-auth_administering_method="${data.auth_administering_method}"
            >
            <div class="meta-wrapper">
                <div class="meta">
                    <h1>
                        <span data-input="name">${data.name}</span>
                        (<span data-input="dosage">${data.dosage}</span> - <span data-input="method">${data.method}</span>)
                    </h1>
                    <h2>
                        <span data-input="start_date">${data.start_date}</span>
                        -
                        <span data-input="end_date">${data.end_date}</span>
                    </h2>
                </div>

                <div class="prescription-status">
                    <span class="status" data-input="status" data-color="${data.status_color}">${data.status}</span>
                </div>
            </div>

            <ul class="details-list table">
                <li>
                    <span class="padding">Instructions</span>
                    <span class="highlight" data-input="instructions" data-color="white">${data.instructions}</span>
                </li>

                <li>
                    <span class="padding">Side Effects</span>
                    <span class="highlight" data-color="white">
                        <em data-input="side_effects">${data.side_effects}</em>
                        <em data-input="side_effects_plan">${data.side_effects_plan}</em>
                    </span>
                </li>

                <li>
                    <span class="padding">Schedule</span>
                    <span class="highlight" data-input="schedule_parsed" data-color="white">${data.schedule_parsed}</span>
                </li>
            </ul>
            
            <div class="file-uploader no-remove" data-url="staff-prescription/${data.prescription}/medication-form" data-file="medication_form">
                <div class="upload-progress">
                    <div class="progress-bar">
                        <div class="current-progress"></div>
                    </div>
                </div>
                
                <div class="file">
                    <div class="meta">
                        <h4>Prescription Authorization</h4>
                        <a href="" class="remove-file icon-trash"></a>
                        <p data-default="Please choose a file">Please choose a file</p>
                    </div>

                    <a href="" class="button select-file">Choose File</a>
                </div>

                <input type="file" data-name="medication_form" accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx">
                <input type="hidden" name="medication_form">
            </div>

            <div class="center-button">
                <a href="" class="margin edit-staff-prescription-trigger" data-color="grey">Edit Prescription</a>
                <a href="staff-prescription/${data.prescription}/download-form" class="margin" data-color="grey" target="_BLANK">Download Form</a>
            </div>
        </div>`);
    }
});